import { render } from "./ClaimExpenseType.vue?vue&type=template&id=f0a3efe4"
import script from "./ClaimExpenseType.vue?vue&type=script&lang=js"
export * from "./ClaimExpenseType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__